import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { pollUrl: String, done: Boolean, i18n: Object }
  static targets = ["progressText", "generatingState", "combiningState", "resultState"]

  connect() {
    if (!this.doneValue) this._startPolling()
  }

  disconnect() {
    this._stopPolling()
  }

  _startPolling() {
    this._interval = setInterval(() => this._poll(), 5000)
  }

  _stopPolling() {
    if (this._interval) clearInterval(this._interval)
  }

  async _poll() {
    try {
      const res = await fetch(this.pollUrlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()

      if (data.status === "processing" || data.status === "pending") {
        if (this.hasProgressTextTarget && data.clips_total > 0) {
          const done = data.clips_completed || 0
          const total = data.clips_total
          this.progressTextTarget.textContent = this._t("scenes_progress", { done, total })
        }
        return
      }

      if (data.status === "failed") {
        this._stopPolling()
        location.reload()
        return
      }

      // All clips done — now watch combine
      if (this.hasGeneratingStateTarget) this.generatingStateTarget.hidden = true
      if (this.hasCombiningStateTarget) this.combiningStateTarget.hidden = false

      if (data.combine_status === "completed" && data.combined_video_url) {
        this._stopPolling()
        location.reload()
      } else if (data.combine_status === "failed") {
        this._stopPolling()
        location.reload()
      }
    } catch (_) {
      // network error — keep polling
    }
  }

  _t(key, vars = {}) {
    if (!this.hasI18nValue) return ""
    let text = this.i18nValue[key] || ""
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(new RegExp(`%\\{${k}\\}`, "g"), v)
    })
    return text
  }
}
